import React from 'react';

import { SearchPartProps } from './search.d';

import SearchGeneral from '/react4xp/components/pages/search-general';

function Search(props: SearchPartProps) {
    return <SearchGeneral {...props} />
}

export default (props) => <Search {...props} />
